// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cancel-container-c3ZVe {
  margin: 0px auto;
  padding: 30px 0px 30px 0px;
  max-width: var(--max-content-width);
}

.Cancel-space4-GO1ig {
  margin-top: 24px;
}

@media screen and (max-width: 1199px) {
  .Cancel-container-c3ZVe {
    padding: 100px 0px 30px 0px;
    margin: 0px auto 0px auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/cancel/Cancel.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;IAC3B,yBAAyB;EAC3B;AACF","sourcesContent":[".container {\n  margin: 0px auto;\n  padding: 30px 0px 30px 0px;\n  max-width: var(--max-content-width);\n}\n\n.space4 {\n  margin-top: 24px;\n}\n\n@media screen and (max-width: 1199px) {\n  .container {\n    padding: 100px 0px 30px 0px;\n    margin: 0px auto 0px auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Cancel-container-c3ZVe`,
	"space4": `Cancel-space4-GO1ig`
};
module.exports = ___CSS_LOADER_EXPORT___;
